import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowsRepeatRightLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrows-repeat-right-left, repost"><path d="M17.25 2.75L20.25 5.75L17.25 8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 21.25L3.75 18.25L6.75 15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.25 18.25H20.25V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 10.25V5.75H18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowsRepeatRightLeft;
